/**
 * M2 onboarding: base layout for each wizard step — progress bar, back, title, content, error, CTA.
 */

import React from 'react';

export default function OnboardingStepLayout({
  step,
  totalSteps,
  title,
  onBack,
  children,
  error,
  notice,
  ctaLabel = 'Continue',
  onCta,
  ctaDisabled = false,
  secondaryActionLabel,
  onSecondaryAction,
  showProgressBar = true,
}) {
  const progressPercent = totalSteps > 0 ? (step / totalSteps) * 100 : 0;

  return (
    <div className="flex flex-col min-h-full">
      {showProgressBar && (
        <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden mb-6">
          <div
            className="h-full bg-[#6B8E6B] rounded-full transition-[width] duration-500 ease-out"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      )}

      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="self-start text-sm text-[#6B8E6B] hover:underline mb-4 focus:outline-none"
        >
          ← Back
        </button>
      )}

      <h2 className="text-xl font-semibold text-[#3A3429] mb-4">{title}</h2>

      <div className="flex-1">{children}</div>

      {notice}

      {error && (
        <p className="mt-3 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}

      {onCta && (
        <div className="mt-10">
          <button
            type="button"
            onClick={onCta}
            disabled={ctaDisabled}
            className="w-full py-2.5 px-4 rounded-md font-medium text-white bg-[#6B8E6B] hover:bg-[#5B785B] disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-[#6B8E6B] focus:ring-offset-2"
          >
            {ctaLabel}
          </button>
        </div>
      )}

      {onSecondaryAction && secondaryActionLabel && (
        <div className="mt-3 text-center">
          <button
            type="button"
            onClick={onSecondaryAction}
            className="border-0 bg-transparent text-sm text-ink-muted hover:text-ink-secondary hover:underline focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2"
          >
            {secondaryActionLabel}
          </button>
        </div>
      )}
    </div>
  );
}
